export default __webpack_public_path__ + "img/caZSOLKq.59f4d668.svg";